import { useState, useEffect } from 'react';
import axios from 'axios';

let groupPermissionCache = null;

export default function useGroupPermissions() {
  const [groupPermissions, setGroupPermissions] = useState(() => groupPermissionCache || []);
  const [loading, setLoading] = useState(groupPermissionCache === null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (groupPermissionCache !== null) return;

    const fetchGroupPermissions = async () => {
      setLoading(true);
      try {
        const res = await axios.get('/api/Admin/user-permissions-basic?forSpecificUser=true', {
          headers: { 'Content-Type': 'application/json' },
        });

        const normalizedNames = res.data.map((permission) => permission.name.replace(/\s+/g, '_').toUpperCase());

        groupPermissionCache = normalizedNames;
        setGroupPermissions(normalizedNames);
      } catch (err) {
        console.error('[useGroupPermissions] Failed to load permissions:', err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchGroupPermissions();
  }, []);

  return { groupPermissions, loading, error };
}
